import React from "react";
import "../Hero.css";
import { Link } from "react-router-dom";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay, EffectFade } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

import {
    FaArrowRight,
    FaShieldAlt,
    FaPlayCircle,
} from "react-icons/fa";

// Cybersecurity Background Images
import slide1 from "../../assets/banner-1.jfif";
import slide2 from "../../assets/banner-8.jfif";
import slide3 from "../../assets/banner-6.jfif";

const Hero = () => {
    return (
        <section className="hero">

            <Swiper
                modules={[
                    Navigation,
                    Pagination,
                    Autoplay,
                    EffectFade,
                ]}
                slidesPerView={1}
                loop={true}
                speed={1200}
                effect="fade"
                autoplay={{
                    delay: 5000,
                    disableOnInteraction: false,
                }}
                navigation
                pagination={{
                    clickable: true,
                }}
                className="hero-slider"
            >

                {/* ===========================
            SLIDE 1
        =========================== */}

                <SwiperSlide>

                    <div
                        className="hero-slide"
                        style={{
                            backgroundImage: `url(${slide1})`,
                        }}
                    >

                        <div className="overlay"></div>

                        <div className="container hero-content">

                            <span className="hero-tag">

                                <FaShieldAlt />

                                Trusted Cybersecurity Partner

                            </span>

                            <h1 style={{fontSize:"40px"}}>

                                Building Secure

                                <h1 style={{color:"#60a5fa", fontSize:"40px"}}> Digital Futures</h1>

                            </h1>

                            <p>

                                BlueLotus Infrasafety Projects Private Limited delivers
                                enterprise cybersecurity solutions that protect your
                                business, infrastructure, cloud, and digital assets
                                from evolving cyber threats.

                            </p>

                            <div className="hero-buttons">

                                <a
                                    href="/consultation"
                                    className="primary-btn"
                                >

                                    Get Consultation

                                    <FaArrowRight />

                                </a>

                                <a
                                    href="/solutions"
                                    className="secondary-btn"
                                >

                                    <FaPlayCircle />

                                    Explore Solutions

                                </a>

                            </div>

                        </div>

                    </div>

                </SwiperSlide>

                {/* ===========================
            SLIDE 2
        =========================== */}

                <SwiperSlide>

                    <div
                        className="hero-slide"
                        style={{
                            backgroundImage: `url(${slide2})`,
                        }}
                    >

                        <div className="overlay"></div>

                        <div className="container hero-content">

                            <span className="hero-tag">

                                AI Powered Security

                            </span>

                            <h1 style={{fontSize:"40px"}}>

                                Protect Your Business

                                <h1 style={{color:"#60a5fa", fontSize:"40px"}}> Against Modern Cyber Threats</h1>

                            </h1>

                            <p>

                                Our proactive cybersecurity strategies safeguard
                                networks, applications, cloud platforms, and endpoints
                                with continuous monitoring and intelligent threat
                                detection.

                            </p>

                            <div className="hero-buttons">

                                <a
                                    href="/consultation"
                                    className="primary-btn"
                                >

                                    Request Assessment

                                    <FaArrowRight />

                                </a>

                                <a
                                    href="/about"
                                    className="secondary-btn"
                                >

                                    Learn More

                                </a>

                            </div>

                        </div>

                    </div>

                </SwiperSlide>

                {/* ===========================
            SLIDE 3
        =========================== */}

                <SwiperSlide>

                    <div
                        className="hero-slide"
                        style={{
                            backgroundImage: `url(${slide3})`,
                        }}
                    >

                        <div className="overlay"></div>

                        <div className="container hero-content">

                            <span className="hero-tag">
                                24×7 Security Operations Center
                            </span>

                            <h1 style={{fontSize:"40px"}}>

                                Stay Protected

                                <h1 style={{color:"#60a5fa", fontSize:"40px"}}> Every Second</h1>

                            </h1>

                            <p>

                                Our Security Operations Center continuously monitors,
                                detects, investigates, and responds to cyber threats,
                                helping your business remain resilient around the clock.

                            </p>

                            <div className="hero-buttons">

                                <a
                                    href="/solutions"
                                    className="primary-btn"
                                >
                                    Our Solutions

                                    <FaArrowRight />
                                </a>

                                <a
                                    href="/contact"
                                    className="secondary-btn"
                                >
                                    Contact Experts
                                </a>

                            </div>

                        </div>

                    </div>

                </SwiperSlide>

            </Swiper>

            {/* =====================================
          SECURITY STATS
      ===================================== */}

            {/* <div className="hero-stats">

                <div className="container">

                    <div className="stats-grid">

                        <div className="stat-card">
                            <h2>100+</h2>
                            <p>Security Projects</p>
                        </div>

                        <div className="stat-card">
                            <h2>24×7</h2>
                            <p>Threat Monitoring</p>
                        </div>

                        <div className="stat-card">
                            <h2>99.9%</h2>
                            <p>Infrastructure Availability</p>
                        </div>

                        <div className="stat-card">
                            <h2>Enterprise</h2>
                            <p>Cybersecurity Solutions</p>
                        </div>

                    </div>

                </div>

            </div> */}

            {/* =====================================
          SCROLL DOWN
      ===================================== */}

            <div className="scroll-indicator">

                <span>Scroll Down</span>

                <div className="mouse">

                    <div className="wheel"></div>

                </div>

            </div>

        </section>

    );
};

export default Hero;